module.exports = __webpack_public_path__ + "static/img/200103.647820f2.png";